import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/grid_sudoku.json";
import fr from "@/locales/fr/puzzle-types/grid_sudoku.json";

export const GRID_SUDOKU_NS = "puzzle-types/grid_sudoku";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerGridSudokuTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", GRID_SUDOKU_NS))
    i18n.addResourceBundle("en", GRID_SUDOKU_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", GRID_SUDOKU_NS))
    i18n.addResourceBundle("fr", GRID_SUDOKU_NS, fr, true, true);
}
